module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0066.jpg?v=4e26eead";